window.Products.DeviceCase.GalaxyS4 = function() {
};
window.Products.DeviceCase.GalaxyS4.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS4.id = 4;
window.Products.DeviceCase.GalaxyS4.slug = 'galaxy-s4';